var a={pageContainer:"pageContainer--9luba",withoutTopPadding:"withoutTopPadding--tUKyE"};export{a as default};
//# sourceMappingURL=PageContainer.module.scss.js.map
